import React from 'react';
import Icon from '../../../components/AppIcon';

const AnalyticsMetricCard = ({ icon, label, value, trend, color = 'primary' }) => {
  const colorClasses = {
    primary: 'bg-primary/10 text-primary',
    success: 'bg-success/10 text-success',
    warning: 'bg-warning/10 text-warning',
    error: 'bg-error/10 text-error'
  };

  const getTrendIcon = () => {
    if (!trend) return null;
    if (trend > 0) return 'TrendingUp';
    if (trend < 0) return 'TrendingDown';
    return 'Minus';
  };

  const getTrendColor = () => {
    if (!trend) return 'text-muted-foreground';
    if (trend > 0) return 'text-success';
    if (trend < 0) return 'text-error';
    return 'text-muted-foreground';
  };

  return (
    <div className="bg-card rounded-xl border border-border shadow-therapeutic p-4 sm:p-6">
      <div className="flex items-start justify-between mb-3">
        <div className={`flex-shrink-0 w-12 h-12 rounded-lg flex items-center justify-center ${colorClasses?.[color]}`}>
          <Icon name={icon} size={24} strokeWidth={2} />
        </div>
        {trend !== undefined && trend !== null && (
          <div className={`flex items-center gap-1 ${getTrendColor()}`}>
            <Icon name={getTrendIcon()} size={16} strokeWidth={2} />
            <span className="text-xs font-medium">
              {Math.abs(trend)}%
            </span>
          </div>
        )}
      </div>
      <div>
        <p className="text-sm text-muted-foreground mb-1">{label}</p>
        <p className="text-2xl sm:text-3xl font-heading font-bold text-foreground">{value}</p>
      </div>
    </div>
  );
};

export default AnalyticsMetricCard;